import React from 'react';
import { WireTransferGroup } from '../../../models/FlowOfFunds/flow-of-funds.model';
import { ConfirmToggleButton } from './ConfirmToggleButton';
import { ConfirmationMeta } from './ConfirmationMeta';

export interface ReceiptConfirmationControlProps {
    group: WireTransferGroup;
    isPending: boolean;
    onConfirm: () => void;
    onUndo: () => void;
}

export const ReceiptConfirmationControl = ({
    group,
    isPending,
    onConfirm,
    onUndo,
}: ReceiptConfirmationControlProps) => {
    if (!group.canConfirmReceipt) {
        return (
            <>
                <span
                    className={`ff-wires__status ${
                        group.receiptConfirmation
                            ? 'ff-wires__status--received'
                            : 'ff-wires__status--pending'
                    }`}>
                    {group.receiptConfirmation ? 'Payment Received' : 'Payment Not Received'}
                </span>
                <ConfirmationMeta confirmation={group.receiptConfirmation} />
            </>
        );
    }

    if (group.receiptConfirmation) {
        return (
            <>
                <ConfirmToggleButton
                    label="Confirm Received"
                    pendingLabel="Undoing…"
                    isOn
                    isPending={isPending}
                    onClick={onUndo}
                />
                <ConfirmationMeta confirmation={group.receiptConfirmation} />
            </>
        );
    }

    return (
        <ConfirmToggleButton
            label="Confirm Received"
            pendingLabel="Confirming…"
            isOn={false}
            isPending={isPending}
            disabled={!group.sentConfirmation}
            onClick={onConfirm}
        />
    );
};
